"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var store_1 = __importDefault(require("store"));

var did_jwt_1 = require("did-jwt");

var ipfs_did_document_1 = __importDefault(require("ipfs-did-document"));

var _3id_blockchain_utils_1 = require("3id-blockchain-utils");

var crypto_1 = require("./crypto");

var did_provider_1 = require("./did-provider");

var keyring_1 = __importDefault(require("./keyring"));

var threeIdProvider_1 = __importDefault(require("./threeIdProvider"));

var utils_1 = require("./utils");

var DID_METHOD_NAME = '3';

var IdentityWallet = /*#__PURE__*/function () {
  function IdentityWallet(getConsent) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, IdentityWallet);

    this.events = new events_1.EventEmitter();
    if (typeof getConsent !== 'function') throw new Error('getConsent parameter has to be a function');
    this._getConsent = getConsent;

    if (config.seed) {
      this._seed = config.seed;
    } else if (config.authSecret) {
      this._authSecret = config.authSecret;
    } else if (config.externalAuth) {
      this._externalAuth = config.externalAuth;
    } else {
      throw new Error('Either seed, or authSecret has to be passed to create an IdentityWallet instance');
    }
  }

  _createClass(IdentityWallet, [{
    key: "get3idProvider",
    value: function get3idProvider() {
      return new threeIdProvider_1.default(this);
    }
  }, {
    key: "getDidProvider",
    value: function getDidProvider() {
      return new did_provider_1.DidProvider(this);
    }
  }, {
    key: "hasConsent",
    value: function hasConsent() {
      var spaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var origin = arguments.length > 1 ? arguments[1] : undefined;

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          address = _ref.address;

      var _a;

      var key = (_a = address !== null && address !== void 0 ? address : this._keyring.getPublicKeys().managementKey) !== null && _a !== void 0 ? _a : '';
      var prefix = "3id_consent_".concat(key, "_").concat(origin !== null && origin !== void 0 ? origin : '', "_");

      var consentExists = function consentExists() {
        var space = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return Boolean(store_1.default.get(prefix + space));
      };

      return spaces.reduce(function (acc, space) {
        return acc && consentExists(space);
      }, consentExists());
    }
  }, {
    key: "getConsent",
    value: function getConsent() {
      var spaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var origin = arguments.length > 1 ? arguments[1] : undefined;

      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          address = _ref2.address;

      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var consent, key, prefix, saveConsent;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.hasConsent(spaces, origin, {
                  address: address
                })) {
                  _context.next = 11;
                  break;
                }

                _context.next = 3;
                return this._getConsent({
                  type: 'authenticate',
                  origin: origin,
                  spaces: spaces,
                  opts: {
                    address: address
                  }
                });

              case 3:
                consent = _context.sent;

                if (consent) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", false);

              case 6:
                key = (_a = address !== null && address !== void 0 ? address : this._keyring.getPublicKeys().managementKey) !== null && _a !== void 0 ? _a : '';
                prefix = "3id_consent_".concat(key, "_").concat(origin !== null && origin !== void 0 ? origin : '', "_");

                saveConsent = function saveConsent() {
                  var space = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                  return store_1.default.set(prefix + space, true);
                };

                saveConsent();
                spaces.map(saveConsent);

              case 11:
                return _context.abrupt("return", true);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getLink",
    value: function getLink() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._seed) {
                  _context2.next = 8;
                  break;
                }

                this._keyring = new keyring_1.default(this._seed);
                _context2.next = 4;
                return this._get3id();

              case 4:
                this.DID = _context2.sent;
                delete this._seed;
                _context2.next = 8;
                return this._linkManagementAddress();

              case 8:
                return _context2.abrupt("return", this._keyring ? this._keyring.getPublicKeys().managementKey : keyring_1.default.walletForAuthSecret(this._authSecret).address);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getRootSigner",
    value: function getRootSigner(pubKeyId) {
      if (pubKeyId == null) {
        return this._keyring.getRootSigner();
      }

      var _pubKeyId$split = pubKeyId.split('#'),
          _pubKeyId$split2 = _slicedToArray(_pubKeyId$split, 2),
          did = _pubKeyId$split2[0],
          keyId = _pubKeyId$split2[1];

      if (this.DID == null || did !== this.DID) {
        throw new Error('Invalid DID');
      }

      return this._keyring.getRootSigner(keyId);
    }
  }, {
    key: "_linkManagementAddress",
    value: function _linkManagementAddress() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var managementWallet;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                managementWallet = this._keyring.managementWallet();
                _context3.t0 = this.events;
                _context3.next = 4;
                return _3id_blockchain_utils_1.createLink(this.DID, managementWallet.address, utils_1.fakeEthProvider(managementWallet));

              case 4:
                _context3.t1 = _context3.sent;

                _context3.t0.emit.call(_context3.t0, 'new-link-proof', _context3.t1);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "linkAddress",
    value: function linkAddress(address, provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var proof;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this._keyring) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('This method can only be called after authenticate has been called');

              case 2:
                _context4.next = 4;
                return _3id_blockchain_utils_1.createLink(this.DID, address, provider);

              case 4:
                proof = _context4.sent;
                this.events.emit('new-link-proof', proof);
                return _context4.abrupt("return", proof);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "linkManagementKey",
    value: function linkManagementKey() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var timestamp, msg;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this._externalAuth) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", null);

              case 2:
                timestamp = Math.floor(new Date().getTime() / 1000);
                msg = "Create a new 3Box profile\n\n- \nYour unique profile ID is ".concat(this.DID, " \nTimestamp: ").concat(timestamp);
                _context5.t0 = msg;
                _context5.t1 = timestamp;
                _context5.next = 8;
                return this._keyring.managementPersonalSign(msg);

              case 8:
                _context5.t2 = _context5.sent;
                return _context5.abrupt("return", {
                  msg: _context5.t0,
                  timestamp: _context5.t1,
                  sig: _context5.t2
                });

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "_initKeyring",
    value: function _initKeyring(authData, address, spaces) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this = this;

        var seed, migratedKeys, proof, _seed;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this._seed) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 3;
                return this.getLink();

              case 3:
                _context6.next = 38;
                break;

              case 5:
                if (!(authData && authData.length > 0)) {
                  _context6.next = 15;
                  break;
                }

                authData.find(function (_ref3) {
                  var ciphertext = _ref3.ciphertext,
                      nonce = _ref3.nonce;
                  seed = keyring_1.default.decryptWithAuthSecret(ciphertext, nonce, _this._authSecret);
                  return Boolean(seed);
                });

                if (seed) {
                  _context6.next = 9;
                  break;
                }

                throw new Error('No valid auth-secret for this identity');

              case 9:
                this._keyring = new keyring_1.default(seed);
                _context6.next = 12;
                return this._get3id();

              case 12:
                this.DID = _context6.sent;
                _context6.next = 38;
                break;

              case 15:
                if (!this._externalAuth) {
                  _context6.next = 31;
                  break;
                }

                if (address) {
                  _context6.next = 18;
                  break;
                }

                throw new Error('External authentication requires an address');

              case 18:
                _context6.next = 20;
                return this._externalAuth({
                  address: address,
                  spaces: spaces,
                  type: '3id_migration'
                });

              case 20:
                migratedKeys = _context6.sent;
                this._keyring = new keyring_1.default(null, migratedKeys);
                _context6.next = 24;
                return this._get3id();

              case 24:
                this.DID = _context6.sent;
                _context6.next = 27;
                return this._externalAuth({
                  address: address,
                  type: '3id_createLink',
                  did: this.DID
                });

              case 27:
                proof = _context6.sent;
                if (proof) this.events.emit('new-link-proof', proof);
                _context6.next = 38;
                break;

              case 31:
                _seed = '0x' + Buffer.from(crypto_1.naclRandom(32)).toString('hex');
                this._keyring = new keyring_1.default(_seed);
                _context6.next = 35;
                return this._get3id();

              case 35:
                this.DID = _context6.sent;
                _context6.next = 38;
                return this.addAuthMethod(this._authSecret);

              case 38:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      var spaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          authData = _ref4.authData,
          address = _ref4.address,
          mgmtPub = _ref4.mgmtPub;

      var origin = arguments.length > 2 ? arguments[2] : undefined;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this2 = this;

        var consent;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!address) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 3;
                return this.getConsent(spaces, origin, {
                  address: address
                });

              case 3:
                consent = _context7.sent;

              case 4:
                if (!(!this._keyring || this._externalAuth)) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 7;
                return this._initKeyring(authData, address, spaces);

              case 7:
                if (!address) consent = this.getConsent(spaces, origin);

                if (consent) {
                  _context7.next = 10;
                  break;
                }

                throw new Error('Authentication not authorized by user');

              case 10:
                return _context7.abrupt("return", {
                  main: this._keyring.getPublicKeys({
                    mgmtPub: mgmtPub
                  }),
                  spaces: spaces.reduce(function (acc, space) {
                    acc[space] = _this2._keyring.getPublicKeys({
                      space: space,
                      uncompressed: true
                    });
                    return acc;
                  }, {})
                });

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      var spaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var origin = arguments.length > 1 ? arguments[1] : undefined;

      var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          address = _ref5.address;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", Boolean(this._keyring) && this.hasConsent(spaces, origin, {
                  address: address
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "addAuthMethod",
    value: function addAuthMethod(authSecret) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var message, encAuthData, authWallet;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this._keyring) {
                  _context9.next = 2;
                  break;
                }

                throw new Error('This method can only be called after authenticate has been called');

              case 2:
                message = this._keyring.serialize();
                encAuthData = keyring_1.default.encryptWithAuthSecret(message, authSecret);
                this.events.emit('new-auth-method', encAuthData);
                authWallet = keyring_1.default.walletForAuthSecret(authSecret);
                _context9.t0 = this.events;
                _context9.next = 9;
                return _3id_blockchain_utils_1.createLink(this.DID, authWallet.address, utils_1.fakeEthProvider(authWallet));

              case 9:
                _context9.t1 = _context9.sent;

                _context9.t0.emit.call(_context9.t0, 'new-link-proof', _context9.t1);

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "signClaim",
    value: function signClaim(payload) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          DID = _ref6.DID,
          space = _ref6.space,
          expiresIn = _ref6.expiresIn,
          useMgmt = _ref6.useMgmt;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var issuer, settings;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this._keyring) {
                  _context10.next = 2;
                  break;
                }

                throw new Error('This method can only be called after authenticate has been called');

              case 2:
                _context10.t0 = DID;

                if (_context10.t0) {
                  _context10.next = 7;
                  break;
                }

                _context10.next = 6;
                return this._get3id(space);

              case 6:
                _context10.t0 = _context10.sent;

              case 7:
                issuer = _context10.t0;
                settings = {
                  signer: this._keyring.getJWTSigner(space, useMgmt),
                  issuer: issuer,
                  expiresIn: expiresIn
                };
                return _context10.abrupt("return", did_jwt_1.createJWT(payload, settings));

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "encrypt",
    value: function encrypt(message, space) {
      var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          nonce = _ref7.nonce,
          blockSize = _ref7.blockSize,
          to = _ref7.to;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var paddedMsg;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (this._keyring) {
                  _context11.next = 2;
                  break;
                }

                throw new Error('This method can only be called after authenticate has been called');

              case 2:
                paddedMsg = typeof message === 'string' ? utils_1.pad(message, blockSize) : message;

                if (!to) {
                  _context11.next = 7;
                  break;
                }

                return _context11.abrupt("return", this._keyring.asymEncrypt(paddedMsg, to, {
                  nonce: nonce
                }));

              case 7:
                return _context11.abrupt("return", this._keyring.symEncrypt(paddedMsg, {
                  space: space,
                  nonce: nonce
                }));

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "decrypt",
    value: function decrypt(encObj, space, toBuffer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var paddedMsg;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (this._keyring) {
                  _context12.next = 2;
                  break;
                }

                throw new Error('This method can only be called after authenticate has been called');

              case 2:
                if (encObj.ephemeralFrom) {
                  paddedMsg = this._keyring.asymDecrypt(encObj.ciphertext, encObj.ephemeralFrom, encObj.nonce, {
                    space: space,
                    toBuffer: toBuffer
                  });
                } else {
                  paddedMsg = this._keyring.symDecrypt(encObj.ciphertext, encObj.nonce, {
                    space: space,
                    toBuffer: toBuffer
                  });
                }

                if (paddedMsg) {
                  _context12.next = 5;
                  break;
                }

                throw new Error('IdentityWallet: Could not decrypt message');

              case 5:
                return _context12.abrupt("return", toBuffer ? paddedMsg : utils_1.unpad(paddedMsg));

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "hashDBKey",
    value: function hashDBKey(key, space) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var salt;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                salt = this._keyring.getDBSalt(space);
                return _context13.abrupt("return", utils_1.sha256Multihash(salt + key));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "_get3id",
    value: function _get3id(space) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var pubkeys, doc, payload, signature;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                pubkeys = this._keyring.getPublicKeys({
                  space: space,
                  uncompressed: true
                });
                doc = new ipfs_did_document_1.default(utils_1.fakeIpfs, DID_METHOD_NAME);

                if (space) {
                  _context14.next = 11;
                  break;
                }

                if (!this.DID) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", this.DID);

              case 5:
                doc.addPublicKey('signingKey', 'Secp256k1VerificationKey2018', 'publicKeyHex', pubkeys.signingKey);
                doc.addPublicKey('encryptionKey', 'Curve25519EncryptionPublicKey', 'publicKeyBase64', pubkeys.asymEncryptionKey);
                doc.addPublicKey('managementKey', 'Secp256k1VerificationKey2018', 'ethereumAddress', pubkeys.managementKey);
                doc.addAuthentication('Secp256k1SignatureAuthentication2018', 'signingKey');
                _context14.next = 21;
                break;

              case 11:
                doc.addPublicKey('subSigningKey', 'Secp256k1VerificationKey2018', 'publicKeyHex', pubkeys.signingKey);
                doc.addPublicKey('subEncryptionKey', 'Curve25519EncryptionPublicKey', 'publicKeyBase64', pubkeys.asymEncryptionKey);
                doc.addAuthentication('Secp256k1SignatureAuthentication2018', 'subSigningKey');
                doc.addCustomProperty('space', space);
                doc.addCustomProperty('root', this.DID);
                payload = {
                  subSigningKey: pubkeys.signingKey,
                  subEncryptionKey: pubkeys.asymEncryptionKey,
                  space: space,
                  iat: null
                };
                _context14.next = 19;
                return this.signClaim(payload);

              case 19:
                signature = _context14.sent.split('.')[2];
                doc.addCustomProperty('proof', {
                  alg: 'ES256K',
                  signature: signature
                });

              case 21:
                _context14.next = 23;
                return doc.commit({
                  noTimestamp: true
                });

              case 23:
                return _context14.abrupt("return", doc.DID);

              case 24:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }]);

  return IdentityWallet;
}();

exports.default = IdentityWallet;